import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const DivStyledBgContainer = styled.div`
  ${({ theme, heroImage }) => {
    const largeUp = theme.largeUp();

    return css`
      width: 100%;
      height: ${largeUp ? rem(480) : rem(250)};
      background-image: url(${heroImage});
      background-size: cover;
      background-position-y: 30%;
      background-position-x: center;
    `;
  }
}`;

export const ColStyled = styled(Col)`
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RowStyled = styled(Row)`
  ${({ theme }) => {
    const largeUp = theme.largeUp();

    return css`
      padding: 0;
      width: 100%;
      flex-direction: ${largeUp ? 'row' : 'column-reverse'};
    `;
  }}
`;

export const SectionContainerStyled = styled(SectionContainer)`
  padding: 0;
  .nmx-container {
    width: 100%;
    max-width: unset;
    margin: 0;
    padding: 0;
  }
`;

export const SpanStyledBlock = styled.span`
  display: block;
`;

export const TypographyStyled = styled(Typography)`
  ${({ theme }) => {
    const largeUp = theme.largeUp();

    return css`
      color: ${theme.colors.brand.pcg.gold1};
      letter-spacing: ${rem(3)};
      font-weight: 400;
      padding: ${largeUp ? 0 : rem(24)} 0;
    `;
  }}
`;

